import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { h3, h4 } from '@helpers/typography';
import MotionTrack from '@stories/Components/Carousels/Carousel/MotionTrack/MotionTrack';
import MotionTrackStyles from '@stories/Components/Carousels/Carousel/MotionTrack/MotionTrack.styles';
import PaginationStyles from '@stories/Components/Carousels/Carousel/Pagination/Pagination.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --items: 1;
  --itemGutter: ${fluid(8, 16)};

  @media ${from(Device.MobileLarge)} {
    --items: 2;
  }

  @media ${from(Device.TabletLarge)} {
    --items: 3;
  }

  @media ${from(Device.Desktop)} {
    --items: 4;
  }
`;
const Title = styled.h2 `
  ${h4};

  margin: 0 0 32px !important;

  h1& {
    ${h3};
  }

  @media ${from(Device.TabletLarge)} {
    ${fonts.apparat.medium};
  }
`;
const CarouselWrapper = styled.div `
  overflow: hidden;
`;
const Track = styled(MotionTrack) `
  ${Container}[data-type='listing'] & {
    ${MotionTrackStyles.Track} {
      display: grid;
      grid-template-columns: repeat(var(--items), 1fr);
      gap: ${fluid(32, 90)} var(--itemGutter);
    }
  }

  ${Container}[data-type='carousel'] & {
    width: calc(100% + var(--itemGutter));
    margin: 0 calc(var(--itemGutter) * -0.5);
  }
`;
const Item = styled.li `
  height: 100%;

  ${Container}[data-type='carousel'] & {
    flex: 0 0 90%;
    padding: 0 calc(var(--itemGutter) * 0.5) 5px;

    @media ${from(Device.MobileLarge)} {
      flex: 0 0 calc(100% / var(--items));
    }

    @media ${from(Device.Tablet)} {
      padding-bottom: 0;
    }
  }
`;
const ControlsWrapper = styled.div `
  ${Container}[data-type='listing'] & {
    display: none;
  }

  ${Container}[data-type='carousel'] & {
    margin: ${fluid(27, 40)} calc(var(--itemGutter) * -0.5) 0;
  }

  ${PaginationStyles.Container} {
    --bgColor: ${brand.base.blue};
  }

  ${PaginationStyles.ControlsWrapper} {
    --fgColor: ${brand.base.blue};
  }
`;
const PeopleListingStyles = {
    Container,
    CarouselWrapper,
    Item,
    Track,
    ControlsWrapper,
    Title,
};
export default PeopleListingStyles;
